<template>
<div>
    <br>
    <!--EVALUACIONES PENDIENTES-->
    <div>
        <div class="bg1 cursor-pointer">
            <p @click="mostrar = !mostrar;changeMenu(mostrar,0)">
                <span v-if="!mostrar"><i class="fa-solid fa-chevron-right cursor-pointer"></i></span>
                <span v-if="mostrar"><i class="fa-solid fa-chevron-down cursor-pointer"></i></span>
                <span class="ml-2"> Evaluaciones pendientes</span>
            </p>
        </div>
        <!--EVALUACIONES PENDIENTES-->
        <div class="hideTipo mt-1" :id="'smenu0'">
            <template v-if="mostrar">
                <template v-if="arrayEvaluacionesPendientes.length > 0">
                    <div v-for="(tr,key) in arrayEvaluacionesPendientes" :key="key" style="width: 100%;">
                        <div style="width: 100%;">
                            <div class="contenedorE" style="width: 100%!important;">
                                <div class="bg2">
                                    <p><span><i class="fa-solid fa-bookmark"></i></span> Disponible hasta: {{ tr.fecha_fin}}</p>
                                </div>
                                <small class="ml-3"> Docente: {{ tr.docente }} | <span>Curso: {{ tr.codigo_curso}} </span></small>
                                <p class="ml-3"><small>Indicaciones: {{ tr.indicaciones }} </small></p>
                                <div class="ml-3" style="padding:5px;">
                                    <p class="enlace" @click="verEvaluacion(tr)" style="font-size:15px;color:brown;">
                                        <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                        <span class="ml-2 cursor-pointer">Ver evaluación</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <p class="m-5">No hay evaluaciones pendientes</p>
                </template>
            </template>
        </div>
        <!--FIN DE EVALUACIONES PENDIENTES-->
    </div>
    <!--EVALUACIONES REALIZADAS-->
    <div class="mt-5">
        <div class="bg1 cursor-pointer" @click="mostrar2 = !mostrar2;changeMenu(mostrar2,1)">
            <p>
                <span v-if="!mostrar2"><i class="fa-solid fa-chevron-right cursor-pointer"></i></span>
                <span v-if="mostrar2"><i class="fa-solid fa-chevron-down cursor-pointer"></i></span>
                <span class="ml-2"> Evaluaciones realizadas</span>
            </p>
        </div>
        <!--EVALUACIONES PENDIENTES-->
        <div class="hideTipo mt-1" :id="'smenu1'">
            <template v-if="mostrar2">
                <template v-if="arrayEvaluacionesFinalizadas.length > 0">
                    <div v-for="(tr,key) in arrayEvaluacionesFinalizadas" :key="key" style="width: 100%;">
                        <div style="width: 100%;">
                            <div class="contenedorE" style="width: 100%!important;">
                                <div class="bg2">
                                    <p><span><i class="fa-solid fa-laptop"></i></span> Disponible hasta: {{ tr.fecha_fin}}</p>
                                </div>
                                <small class="ml-3"> Docente: {{ tr.docente }} | <span>Curso: {{ tr.codigo_curso}} </span></small>
                                <p class="ml-3"><small>Indicaciones: {{ tr.indicaciones }} </small></p>
                                <div class="ml-3" style="padding:5px;">
                                    <p class="enlace" @click="verEvaluacion(tr)" style="font-size:15px;color:brown;">
                                        <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                        <span class="ml-2 cursor-pointer">Ver Evaluación</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <p class="m-5">No hay evaluaciones finalizadas</p>
                </template>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import GeneralMixin from "@/mixins/GeneralMixin.js";
export default {
    mixins: [GeneralMixin],
    data() {
        return {
            arrayEvaluacionesPendientes: [],
            arrayEvaluacionesFinalizadas: [],
            mostrar: true,
            mostrar2: false,
            usuario: [],
            codigoCurso: '',
        }
    },
    created() {
        // let me = this
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0]
        this.codigoCurso = localStorage.getItem('codigo_curso')
    },
    mounted() {
        this.getEvaluaciones()
        setTimeout(() => {
            this.changeMenu(true, 0)
        }, 1000);
    },
    methods: {
        getEvaluaciones() {
            let me = this;
            me.arrayEvaluacionesPendientes = []
            me.arrayEvaluacionesFinalizadas = []
            me.$vs.loading()
            const {
                idusuario
            } = me.usuario
            me.$http.get(this.$server_url + `evaluacionEstudiante?getEvaluaciones=1&codigo=${ me.codigoCurso }&estudiante=${ idusuario }`)
                .then(function (response) {
                    me.$vs.loading.close()
                    me.arrayEvaluacionesPendientes = response.data.evaluacionesPendientes;
                    me.arrayEvaluacionesFinalizadas = response.data.evaluacionesRealizadas;
                })
                .catch(function () {
                    me.$vs.loading.close()
                    me.f_notificaciones('Error al cargar las evaluaciones', 'danger')
                })
        },
        verEvaluacion(tr) {
            localStorage.setItem('ide', tr.id)
            this.$router.push('/estudiante/mostrar-evaluaciones');
        },
        changeMenu(boleano, id) {
            // let me = this
            const tipo = document.querySelector("#smenu" + id);
            if (boleano) {
                tipo.classList.remove("hideTipo");
                tipo.classList.toggle("showTipo");
            } else {
                tipo.classList.remove("showTipo");
                tipo.classList.toggle("hideTipo");
            }
        },
    }
}
</script>

<style scoped>
.bg1 {
    background: #f6f6f6;
    padding: 20px;
    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
    font-weight: 600;
    font-size: 15px;
    color: #2d3e5f;
    border: 2px solid #e9e6e6;
}

.contenedorE {
    border-left: 8px solid rgba(var(--vs-primary), 1) !important;
    border-start-start-radius: 8px;
    border-end-start-radius: 8px;
}

.bg2 {
    /*haz un border left 2px solid #000 pero que las esquinas sean redondas*/

    margin-top: 20px;
    margin-bottom: 20px;
    /*border-left: 2px solid #000;*/
    width: 100%;
    padding: 20px;
    font-family: monospace;
    font-weight: 200;
    font-size: 15px;
    color: #22252b;
    border: 1px solid #f2f2f2;
    cursor: pointer;
    color: rgb(121, 118, 115);
    display: flex;
    justify-content: space-between;
}

.enlace {
    transition: 1s ease all;
    font-size: 12px;
}

.enlace:hover {
    color: #457a92;
    text-decoration: underline;
    transform: translateY(-1px);
}

/*ESTILOS MENU*/
/*SHOW / SHOW*/
.showTipo {
    display: flex;
    flex-wrap: wrap;
    transition: 1s ease all;
    opacity: 1;
    transform: translateY(0%);
}

.hideTipo {
    opacity: 0;
    position: relative;
    transition: 2s ease all;
    transform: translateY(-30%);
}

/*fin hide/show*/
.fade-in {
    opacity: 1;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 0.5s;
    padding: 10px;
    border: 1px solid #f2f2f2;
    max-height: 90%;
    margin-top: -1px !important;
}

@keyframes fadeInOpacity {
    0% {
        transform: translateX(30%);
        opacity: 0;
    }

    50% {
        transform: translateX(10%);
        opacity: 0.5;
    }

    100% {
        opacity: 1;
        transform: translateX(0%);
    }
}

/*media query*/
@media (max-width: 412px) {}

/*estilos evaluaciones*/
</style>
